import React from 'react';
import { Phone, Mail } from 'lucide-react';

export default function StickyActions() {
  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-40 flex flex-col space-y-px">
      <a
        href="tel:+4586692099"
        className="bg-blue-700 hover:bg-blue-800 text-white p-4 transition-colors duration-200 flex items-center justify-center whitespace-nowrap"
        title="Ring til os"
      >
        <Phone className="w-6 h-6" />
      </a>
      <a
        href="mailto:info@moeldrupvvs.dk"
        className="bg-slate-900 hover:bg-slate-950 text-white p-4 transition-colors duration-200 flex items-center justify-center whitespace-nowrap"
        title="Send en mail"
      >
        <Mail className="w-6 h-6" />
      </a>
    </div>
  );
}
